module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Fettl","short_name":"Fettl","start_url":"/","background_color":"#3FA1D2","theme_color":"#3FA1D2","display":"minimal-ui","icon":"src/images/fettl-logo-bw_on_w.svg","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"20b7d17e46f0e6fc422bfe9293ec634d"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
